module.exports = __webpack_public_path__ + "static/media/reply.fb107040.svg";